<template>
    <div class="tab-text">
        <div class="vx-row mb-6" style="width: 50%">
            <div class="vx-col sm:w-1/3 w-full flex items-center">
                <span>File</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <input
                class="inputx"
                type="file"
                v-if="uploadReady"
                ref="file"
                name="file"
                accept=".xls, .xlsx"
                />
            </div>
        </div>
        <div class="vx-row mb-6" style="width: 50%">
            <div class="vx-col sm:w-1/3 w-full flex items-center"></div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-button class="ml-auto mt-2" v-on:click="handleSubmit">Submit</vs-button>
                <vs-button
                    class="ml-4 mt-2"
                    type="border"
                    color="warning"
                    v-on:click="handleDownload"
                    >Download Template</vs-button>
                
                <!-- <vs-button
                    class="ml-4 mt-2"
                    type="border"
                    color="warning"
                    @click.stop="downloadFileAwsS3('/templates/TemplateCustomer.xlsx')"
                >Download Template</vs-button>     -->
            </div>
        </div>

        <div class="vx-row mb-12">
			<div
				v-bind:class="[
				detail ? detailShow + ' vertical-divider' : '',
				detailHide,
				]"
			>
        <vs-table
            search
            stripe
            border
            description
            :sst="true"
            :data="table.data"
            :max-items="table.length"
            :total="table.total"
            @search="handleSearch"
            @change-page="handleChangePage"
            @sort="handleSort"
        >
            <template slot="header">
                <vs-dropdown vs-trigger-click class="cursor-pointer">
                <div
                    class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                >
                    <span class="mr-2">{{this.table.start}} - {{this.table.end}} of {{this.table.total}}</span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <vs-dropdown-menu>
                    <vs-dropdown-item
                        v-for="item in table.limits"
                        :key="item"
                        @click="handleChangelength(item)"
                    >
                    <span>{{item}}</span>
                    </vs-dropdown-item>
                </vs-dropdown-menu>
                </vs-dropdown>
            </template>
            <template slot="thead">
                <vs-th>No</vs-th>
                <vs-th sort-key="file_name">File</vs-th>
                <vs-th sort-key="start_process_at">Start Process</vs-th>
                <vs-th sort-key="end_process_at">End Process</vs-th>
                <vs-th>Status</vs-th>
                <vs-th>Remark</vs-th>
                <vs-th>Imported By</vs-th>
                <vs-th>Action</vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{ indextr+1 }}</vs-td>
                    <vs-td :data="data[indextr].FilePath"><a href="#" v-on:click="downloadFileAwsS3(tr.FilePath)">File Uploaded</a></vs-td>
				    <vs-td :data="data[indextr].StartProcessAt">{{ dateFormat(tr.StartProcessAt) }}</vs-td>
				    <vs-td :data="data[indextr].EndProcessAt">{{ dateFormat(tr.EndProcessAt) }}</vs-td>
                    <vs-td> {{ tr.Status }} </vs-td>
                    <vs-td> {{ tr.Remark }} </vs-td>
                    <vs-td>{{ tr.CreatedBy.name }}</vs-td>
                    <vs-td>
                        <a><vs-button class="mt-2 ml-2" color="primary" type="border" icon-pack="feather" icon="icon-search" v-on:click="showDetail(tr)"></vs-button></a>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
        <vs-pagination
            style="padding-top:5px"
            :total="table.totalPage"
            v-model="setPage"
        />
        </div>
        <vs-popup fullscreen title="Log Details" :active.sync="detail">
			<div class="vx-row mb-6">
				<div class="vx-col w-full" v-if="detail">
					<datatableDetail :selected="selected"></datatableDetail>
				</div>
			</div>
		</vs-popup>
		</div>
    </div>
</template>

<script>
import moment from 'moment'
import datatableDetail from "./datatable-detail.vue";
export default {
    components: {
        datatableDetail
    },
    data() {
        return {
            uploadReady: true,
			detail: false,
			detailShow: "vx-col md:w-1/2 w-full mb-base",
			detailHide: "core vx-col md:w-1/1 w-full mb-base",
            table: {
                data: [],
                length: 10,
                page: 1,
                search: "",
                order: "id",
                sort: "desc",
                total: 0,
                totalPage: 0,
                totalSearch: 0,
                limits: [10, 25, 50, 100, "All"],
                start: 1,
                end: 0
            }
        };
    },
    methods: {
        handleDownload() {
            // promotion/download-excel
            this.$vs.loading();
            var fileTitle =
              "IMPORT PROMOTION TEMPLATE_" + moment().format("YYYYMMDDHHmmss");
      
            this.$http
              .get("/api/v2/promotion/download-excel", {
                responseType: "arraybuffer",
                headers: {
                  Accept: "application/octet-stream",
                },
              })
              .then((resp) => {
                this.$vs.loading.close();
                if (resp.status == "error") {
                  this.$vs.notify({
                    color: "danger",
                    title: "Error",
                    text: resp.message,
                    position: "top-right",
                    iconPack: "feather",
                    icon: "icon-x-circle",
                  });
                } else {
                  var fileURL = window.URL.createObjectURL(new Blob([resp]));
                  var fileLink = document.createElement("a");
                  fileLink.href = fileURL;
      
                  fileLink.setAttribute(
                    "download",
                    fileTitle.toUpperCase() + ".xlsx"
                  );
                  document.body.appendChild(fileLink);
                  fileLink.click();
                }
              });
        },
        handleSubmit() {
            var file = this.$refs.file.files[0];
            if (file == null) {
                this.$vs.notify({
                    color: "danger",
                    title: "Form Validation",
                    text: "File is required",
                    position: "top-right",
                    iconPack: "feather",
                    icon: "icon-x-circle",
                });
            } else {
                var dateNow = new Date();
                var now =
                    dateNow.getFullYear() +
                    "" +
                    (dateNow.getMonth() + 1) +
                    "" +
                    dateNow.getDate();
                now +=
                    +"" +
                    dateNow.getHours() +
                    "" +
                    dateNow.getMinutes() +
                    "" +
                    dateNow.getSeconds();
                this.formData = new FormData();
                this.formData.append("file_promotions", file);
                this.formData.append("user_agent", navigator.userAgent)
                this.formData.append("file_name", (now + "_" + file.name));
                this.formData.append("url", "/api/v2/create-update-promotions-upload-form");
                this.formData.append("action", "import");
                this.$vs.loading();
                this.$http
                .post("/api/v2/create-update-promotions-upload-form", this.formData, {
                    headers: {
                    "Content-Type": "multipart/form-data",
                    },
                })
                .then((resp) => {
                    this.$vs.loading.close();
                    if (resp.status == "success") {
                        this.$vs.notify({
                            color: "success",
                            title: "Success",
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle",
                        });
                        this.uploadReady = false;
                        this.$nextTick(() => {
                            this.uploadReady = true;
                        });
                        this.getData2()
                    } else {
                        this.$vs.notify({
                            color: "danger",
                            title: "Error",
                            text: resp.message,
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle",
                        });
                    }
                })
                .catch((error) => {
                    this.$vs.notify({
                        color: "danger",
                        title: "Error",
                        text: error,
                        position: "top-right",
                        iconPack: "feather",
                        icon: "icon-x-circle",
                    });
                });
            }
        },
        handleSearch(searching) {
            this.table.search = searching;
            this.table.page = 1;
            this.getData2()
        },
        handleChangePage(page) {
            this.table.page = page;
            this.getData2()
        },
        handleSort(key, active) {
            this.table.order = key;
            this.table.sort = active;
            this.getData2()
        },
        handleChangelength(val) {
            this.table.length = val == "All" ? this.table.total : val;
            this.table.page = 1;
            this.getData2()
        },
        closeDetail() {
		    this.detail = false;
		},
        showDetail(data) {
            console.log("data", data)
            this.selected = data;
			this.detail = true;
		},
        getData2() {
            this.$vs.loading();
            this.$http
            .get("/api/v2/log-import-promotion", {
                params: {
                    length: this.table.length,
                    page: this.table.page,
                    search: this.table.search,
                    order: this.table.order,
                    sort: this.table.sort,
                    type: "promotion-v2"
                }
            })
            .then(resp => {
                console.log(resp);
                if (resp.status == "success") {
                    this.table.total = resp.data.total_record;
                    this.table.totalPage = resp.data.total_page;
                    this.table.totalSearch = resp.data.total_record_search;
                    this.table.length = resp.data.total_record_per_page;
                    this.table.data = resp.data.records;
                    this.setStartEnd();
                    this.$vs.loading.close();
                } else {
                    console.log(resp.message);
                }
            });
        },
        setStartEnd() {
            let valStart = this.table.length * this.table.page - this.table.length + 1;
            if (valStart > this.table.total) {
                valStart = 1;
            }
            if (this.table.total == 0) {
                valStart = 0;
            }
            let valEnd = this.table.length * this.table.page;
            if (valEnd > this.table.total) {
                valEnd = this.table.total;
            }
            if (this.table.totalSearch < this.table.total) {
                valEnd = this.table.totalSearch;
            }

            this.table.start = valStart;
            this.table.end = valEnd;
        },
        dateFormatGMT7(date) {
            if (date) {
				// ini karena datanya berformat `date time`, bukan `datetimezone`
				// jadi GMT(+7) ditambah +7 =>utc offset = 14
                return moment(String(date)).utcOffset(14).format('DD/MM/YYYY HH:mm')
            }
        },
        dateFormat(date) {
            if (date) {
                return moment(String(date)).format("DD-MM-YYYY HH:mm");
            }
        },
    },
    mounted() {},
    watch: {},
    computed: {
        setPage: {
            get() {
                return 1;
            },
            set(val) {
                this.handleChangePage(val);
            }
        }
    }
};
</script>